// Minimal API client — sends credentials (cookies) + CSRF token with every request.
let csrfToken = null;
export async function fetchCsrf() {
    const res = await fetch('/api/csrf', { credentials: 'include' });
    if (!res.ok)
        throw new Error('Failed to fetch CSRF token');
    const data = await res.json();
    if (!data.token)
        throw new Error('CSRF token not found in response');
    csrfToken = data.token;
}
export async function api(path, options = {}) {
    const method = options.method ?? 'GET';
    const isMutation = ['POST', 'PUT', 'PATCH', 'DELETE'].includes(method);
    if (isMutation) {
        await fetchCsrf();
    }
    else if (!csrfToken) {
        await fetchCsrf();
    }
    const res = await fetch(path, {
        ...options,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            ...(isMutation && csrfToken ? { 'X-CSRF-Token': csrfToken } : {}),
            ...options.headers,
        },
    });
    if (!res.ok) {
        if (res.status === 401) {
            // Session expired — redirect to login
            window.location.href = '/admin';
            throw new Error('Session expired');
        }
        const err = await res.json().catch(() => ({ error: { message: res.statusText } }));
        let message = err.error?.message ?? 'Request failed';
        if (err.error?.issues && Array.isArray(err.error.issues)) {
            message = err.error.issues.map((i) => `${i.path.join('.') || 'field'}: ${i.message}`).join('; ');
        }
        throw new Error(message);
    }
    return res.json();
}
export async function apiDownload(path) {
    const res = await fetch(path, { credentials: 'include' });
    if (!res.ok)
        throw new Error('Download failed');
    return res.blob();
}
